import React from "react";

import ParallaxImage from "../ParallaxImage";
import { ReactLenis } from "@studio-freight/react-lenis";
import "../../css/SelectionBg.css";
import InteriorDesignResidentialSelectionComponent from "../InteriorDesignComponents/InteriorDesignResidentialSelection";
import LuxeSelection from "../Selection2/LuxeSelection";
import BeysuSelection from "../Selection2/BeysuSelection";
import CommercialSelectionComponent from "./CommercialSelectionComponent";
import MagellanSelection from "../Selection2/MagellanSelection";
import MagellanShow from "./commercialimagesshow/MagellanShow";
import DawlanceSelection from "../Selection2/DawlanceSelection";
import UmmbabSelection from "../Selection2/UmmbabSelection";
import UmmbabShow from "./commercialimagesshow/ummbabshow";
import UmmbabShow2 from "./commercialimagesshow/ummbabShow2";

export default function UmmbabComponent() {
  return (
    <ReactLenis root>
      <div className="app1">
        <section className="hero">
          <div className="img">
            <ParallaxImage
              src="../../Images/CommercialImages/6UmmBabTower/DESIGN/LOBBY/6.png"
              alt=""
            />
          </div>

          <div className="nav">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: "200px",
              }}
            >
              <p className="p5">UMM BAB TOWER</p>
              {/* <p>COMMERCIAL INTERIOR DESIGN</p>
              <p>EXTERIOR DESIGN</p> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "10px",
                  color: "#e7e7e7",
                  textTransform: "uppercase",
                  fontSize: "20px",
                }}
              >
                <span>
                  role in project: architectural drawings, 3d visualization,
                  <br />
                  Fit-Out, Manufacturing of Furnitures,
                  <br />
                  Fixtures and Equipments, Project Execution
                </span>
                <span>project duration: 1 year</span>
                <span>year of completion: 2024</span>
                <span>project location:Westbay, Doha-QATAR</span>
              </div>
            </div>
          </div>
        </section>
        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "40px",
                  textTransform: "uppercase",
                }}
              >
                Affordable, functional living spaces designed for comfort,
                community, and convenience
              </h1>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>
        <section className="projects">
          <div className="img">
            <ParallaxImage
              src="../../Images/CommercialImages/6UmmBabTower/DESIGN/HOUSES/1.png"
              alt=""
            />
          </div>

          {/* <div className="projects-brief">
              <p
                style={{
                    color:"black",
                    fontSize:"30px"
                }}
              >
              This modern living space and bedroom are designed to inspire with its elegant lines, warm tones, and luxurious finishes, creating an inviting ambiance for both relaxation and entertaining.
              </p>
            </div> */}

          <div className="col projects-cover">
            <div
              className="img"
              style={{
                marginTop: "1000px",
                zIndex: "9999",
              }}
            >
              {/* <ParallaxImage
                src="../../Images/CommercialImages/6UmmBabTower/DESIGN/ELEVATOR.png"
                alt=""
              /> */}
            </div>
          </div>

          <div className="col projects-list">
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                affordable
                <br />
                living
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                with
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                Practical
                <br />
                Elegance
              </h1>
            </div>
          </div>
        </section>

        <section className="about">
          <div className="col intro">
            <p>ABOUT</p>
            <p
              style={{
                width: "450px",
              }}
            >
              This 27-story residential tower, spanning 45,000 square meters, is
              designed primarily to offer practical and affordable living
              spaces. With 184 apartments in four layouts—102 one-bedroom units,
              76 three-bedroom units, and 6 duplexes—the building prioritizes
              functionality over luxury.
            </p>
          </div>
          <div className="col portrait">
            <div className="portrait-container">
              <div className="img">
                <ParallaxImage
                  src="../../Images/CommercialImages/6UmmBabTower/COMPLETED/LOBBY/2.jpeg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </section>

        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "30px",
                  textTransform: "uppercase",
                  padding:"100px"
                }}
              >
                As the renovation coordinator for the main contractor, the
                design team and construction activities for the lobby,
                corridors, gym, children's playground, and apartments were
                managed with a focus on enhancing comfort and functionality for
                residents, ensuring that all upgrades were cost-effective and
                stayed within budget constraints.
              </h1>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>

        <section className="banner">
          <UmmbabSelection />
        </section>

      

        {/* <section className="footer1">
          <div className="col">
            <p>Instagram</p>

            <div className="footer-links">
              <p>Luxe Residance</p>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                "A Perfect Blend
              </h1>
              <h1> of Style and Comfort."</h1>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                A2Z Design & Build
              </h1>
            </div>
          </div>

       
          <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div>
        </section> */}

        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "40px",
                }}
              >
                “Elevating everyday living with thoughtful design solutions,
                tailored to maximize comfort and functionality within
                budget-friendly parameters."
              </h1>
              <p>A2Z Design Studio</p>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>
        <div>
        <h1
            style={{
              marginBottom:"20px",
              textAlign:"center",
              textTransform:"uppercase",
              fontSize:"35px",
              fontWeight:"100"
            }}
          >
          3d visualizations
          </h1>
      
        <UmmbabShow />
        </div>
        <div>
        <h1
            style={{
              marginBottom:"20px",
              textAlign:"center",
              textTransform:"uppercase",
              fontSize:"35px",
              fontWeight:"100",
              marginTop:"50px"
            }}
          >
          completed projects
          </h1>
        <UmmbabShow2 />
        </div>
        
        <CommercialSelectionComponent />
      </div>
    </ReactLenis>
  );
}
